<template>
  <AppHeader>Bottle Exchange Entry</AppHeader>

  <Loading v-if="state === 'loading'"></Loading>

  <div v-if="state == 'idle'" class="p-4">
    <div class="p-3 text-gray-600 bg-white shadow rounded-2xl">
      <div class="px-2 py-1 border-2 rounded-xl border-slate-100">
        <p class="text-gray-600">Type</p>
        <input v-model="owner_type" class="w-full text-xl placeholder:text-lg" placeholder="Enter type" type="text" disabled>
        <p class="w-full mt-1 text-sm text-left text-red-300" v-if="errors.owner_type">{{ errors.owner_type }}</p>
      </div>

      <div class="px-2 py-1 mt-3 border-2 rounded-xl border-slate-100">
        <p class="text-gray-600">Name</p>
        <input type="text" v-model="owner_name" class="w-full text-xl" disabled>
      </div>

      <div class="px-2 py-1 mt-3 border-2 rounded-xl border-slate-100">
        <p class="text-gray-600">Date</p>
        <input  v-model="date" class="w-full text-xl placeholder:text-lg" type="date" :max="maxDate">
        <p class="w-full mt-1 text-sm text-left text-red-300" v-if="errors.date">{{ errors.date }}</p>
      </div>

      <div class="px-2 py-1 mt-3 border-2 rounded-xl border-slate-100">
        <p class="text-gray-600">Type</p>
        <div class="flex justify-around my-3">
          <div class="flex gap-2">
            <input type="checkbox" :checked="type === 'given'" @change="toggleGiven('given')" id="given">
            <p class="text-gray-600">Given</p>
          </div>

          <div class="flex gap-2" v-if="selectedType !== 'breakage' && selectedType !== 'missing'">
            <input type="checkbox" :checked="selectedType === 'taken'" @change="toggleType('taken')" id="taken">
            <p class="text-gray-600">Taken</p>
          </div>

          <div class="flex gap-2" v-if="selectedType !== 'taken' && selectedType !== 'missing'">
            <input type="checkbox" :checked="selectedType === 'breakage'" @change="toggleType('breakage')" id="breakage">
            <p class="text-gray-600">Breakage</p>
          </div>

          <div class="flex gap-2" v-if="selectedType !== 'taken' && selectedType !== 'breakage'">
            <input type="checkbox" :checked="selectedType === 'missing'" @change="toggleType('missing')" id="missing">
            <p class="text-gray-600">Missing</p>
          </div>
        </div>

        <div class="mt-5" v-if="type === 'given'">
          <p class="text-gray-300 text-xl">{{ capitalize(type) }}</p>
          <div class="flex items-center gap-4 mt-2" v-for="sp in subscription_products" :key="'given-' + sp.id">
            <p class="w-full py-1 text-lg px-3">{{ sp.name }}</p>
            <div class="flex items-center bg-gray-100 gap-4 rounded-lg">
              <button class="py-1 px-3 bg-gray-300 text-black rounded-lg text-lg" @click="decrease(sp, 'given')"><i class="icon ion-md-remove"></i></button>
              <p class="text-gray-800 text-lg text-center w-4">{{ counts.given[sp.id] || 0 }}</p>
              <button class="py-1 px-3 bg-gray-300 text-black rounded-lg text-lg" @click="increase(sp, 'given')"><i class="icon ion-md-add"></i></button>
            </div>
          </div>
        </div>

        <div class="mt-5" v-if="['taken','breakage','missing'].includes(selectedType)">
          <p class="text-gray-300 text-xl">{{ capitalize(selectedType) }} </p>
          <div class="flex items-center gap-4 mt-2" v-for="sp in subscription_products" :key="sp.id">
            <p class="w-full py-1 text-lg px-3">{{ sp.name }}</p>
            <div class="flex items-center bg-gray-100 gap-4 rounded-lg">
              <button class="py-1 px-3 bg-gray-300 text-black rounded-lg text-lg" @click="decrease(sp, selectedType)"><i class="icon ion-md-remove"></i></button>
              <p class="text-gray-800 text-lg text-center w-4">{{ counts[selectedType][sp.id] || 0 }}</p>
              <button class="py-1 px-3 bg-gray-300 text-black rounded-lg text-lg" @click="increase(sp, selectedType)"><i class="icon ion-md-add"></i></button>
            </div>
          </div>
        </div>
      </div>

      <div class="mt-5 text-center">
        <button class="px-3 py-2 text-sm leading-none text-gray-600 uppercase rounded-full bg-slate-300" @click="submitEmptyBottleForm">Create Entries</button>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from '@/utils/mixin.js';
import formMixin from '@/utils/mixins/form.js';
import AppHeader from '@/components/common/Header.vue';
import Loading from '@/components/common/Loading.vue';

export default {
  name: 'BottleExchangeCreate',
  mixins: [ mixin, formMixin ],
  components: { AppHeader, Loading },
  data() {
    return {
      state: 'idle',
      type: null,
      selectedType: null,
      owner_name: '',
      owner_type: '',
      owner_id: '',
      date: null,
      maxDate: new Date().toISOString().split('T')[0],
      form: [],
      subscription_products: [],
      counts: { given: {}, taken: {}, breakage: {}, missing: {} }
    }
  },

  methods: {
    getData() {
      this.state = 'loading';

      this.request('GET', 'customer-bottle-exchange/create', {}, (resp) => {
        this.state = 'idle';
        if (resp.success) {
          this.owner_id = this.$route.params.id;
          this.owner_type = this.$route.query.type;
          this.owner_name = this.$route.query.name;
          this.subscription_products = resp.data.subscription_products;
        } else alert(resp.message);
      });
    },

    toggleGiven() {
     if (this.type === 'given') {
        this.counts.given = {};
        this.type = null;
      } else {
        this.type = 'given';
        if (!this.counts.given) this.counts.given = {};
      }
    },

    toggleType(type) {
      if (this.selectedType === type) {
        this.counts[type] = {};
        this.selectedType = null;
      } else {
        this.selectedType = type;
        if (!this.counts[type]) this.counts[type] = {};
      }
    },

    capitalize(str) {
      if (!str) return '';
      return str.charAt(0).toUpperCase() + str.slice(1);
    },

    increase(sp, type) {
      if (!this.counts[type][sp.id]) this.counts[type][sp.id] = 0;
      this.counts[type][sp.id]++;
    },
    decrease(sp, type) {
      if (!this.counts[type][sp.id]) this.counts[type][sp.id] = 0;
      if (this.counts[type][sp.id] > 0) this.counts[type][sp.id]--;
    },

    prepareEmptyBottleData() {
      const data = [];

      Object.keys(this.counts).forEach(type => {
        const products = this.counts[type];
        Object.keys(products).forEach(product_id => {
          const count = products[product_id];
          if (count > 0) {
            data.push({
              date:this.date,
              owner_id: this.owner_id,
              owner_type: this.owner_type,
              product_id: parseInt(product_id),
              type,
              count
            });
          }
        });
      });

      return data;
    },

    submitEmptyBottleForm() {
      this.form = this.prepareEmptyBottleData();

      let commonData = {
        date: this.date,
        owner_id: this.owner_id,
        owner_type: this.owner_type,
      };

      let validationRules = {
        date: 'required',
        owner_id: 'required|numeric',
        owner_type: 'required|notempty',
      };

      if (!this.validateForm(commonData, validationRules)) return;

      if (this.form.length === 0) {
        alert('Please add at least one product count under any type');
        return;
      }

      this.state = 'loading';
      this.request('POST', 'customer-bottle-exchange/create', this.form , (resp) => {
        this.state = 'idle';
        if (resp.success) {
          alert(resp.message);
          this.counts = { given: {}, taken: {}, breakage: {}, missing: {} };
          this.selectedType = null;
          this.type = null;
          this.date = '';
          this.$router.go(-1);
        } else alert(resp.message);
      });
    }
  },

  created() {
    this.getData();
    let today = new Date();
    this.date = today.toISOString().substr(0, 10);
  }
}
</script>
